const Config = {
    BaseUrl: process.env.REACT_APP_BaseUrl!,
    CourseUrl: process.env.REACT_APP_CourseUrl!,
    LiveUrl: process.env.REACT_APP_LiveUrl!,
    LiveUrlClient: process.env.REACT_APP_LiveUrl_Client!,
    CasUrl: "https://sso.dufe.edu.cn",
    PreviewUrl: process.env.REACT_APP_PreviewUrl!,
    ApiHost: process.env.REACT_APP_API_HOST!,
    WsHost: process.env.REACT_APP_WS_HOST!,
    CustomCode: "kb_dconline",
    Title: process.env.REACT_APP_TITLE!,
    DefaultBatch: "",
    MaxWeek: parseInt(process.env.REACT_APP_MaxWeek!), // 最大周数,
    QiNiuUploadUrl: "https://up-z1.qiniup.com",
    QiNiuDownloadUrlResource: "https://niukczy.edufe.com.cn",
    QiNiuDownloadUrl: "https://niu.edufe.com.cn",
    PolyUid: "5c0ad4c56c"
};

export default Config;
